import { render } from "./PhoCard.vue?vue&type=template&id=258be66a"
import script from "./PhoCard.vue?vue&type=script&lang=js"
export * from "./PhoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__